import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, Modal, PrimaryButton, TextField } from '@fluentui/react';
import "../Styles/ShareStudyLinkCss.css";
import { shareStudyLinkApi, shareStudyToUsersApi } from '../../../../service/StudyListService';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { ShareStudyLinkSchema } from './ShareStudyLinkSchema';
import ShareStudyContext from '../../../../context/sharestudy/ShareStudyContext';
import ShareStudyLinkBody from './ShareStudyLinkBody';
import ModalMain from '../../../../components/Modal/ModalMain';

const ShareStudyLink = (props) => {

    const { fetchShareStudyUrl, 
        studyShareUrl, 
        showShareStudyLinkModal, 
        setShowShareStudyLinkModal, 
        shareStudyByMail} = useContext(ShareStudyContext);

    const [t] = useTranslation();
    // const [studyShareEmail, setStudyShareEmail] = useState("");
    const [isEmailChecked, setIsEmailChecked] = useState(true);
    const [loadingState, setLoadingState] = useState("");
    const [loading, setLoading] = useState(false);
    // const [studyShareUrl, setStudyShareUrl] = useState("");

    const getStudyUrl = () =>{
        fetchShareStudyUrl(props.studyId, props.firmId, props.clientId);
    }

    useEffect(()=>{
        getStudyUrl();
    },[]);

    const handleEmailcheck = () =>{
        if(isEmailChecked){
            setIsEmailChecked(false);
        }else{
            setIsEmailChecked(true);
        }
    }

    const handleClose = () =>{
        setShowShareStudyLinkModal(false);
        if( props.setShowShareStudyLinkModal != undefined){
            props.setShowShareStudyLinkModal(false);
        }
    }

    const handleDonePayload = (values) =>{
        return {
            mail: isEmailChecked?values.email:"",
            whatsappNo:"",
            SMSNo:"",
            sharedUrl: values.studyShareUrl,
            mailChacked: isEmailChecked,
            smsChacked: false,
            whatsappChacked: false

        }
    }

      const {
        values,
        errors,
        handleChange,
        handleSubmit,
      } = useFormik({
        initialValues:  {
            studyShareUrl: studyShareUrl !=""?studyShareUrl:props.studyShareUrl,
            email: "",
        },
        enableReinitialize: true,
        validationSchema: isEmailChecked === true ? ShareStudyLinkSchema : null,
        onSubmit: async (values) => {
            if(isEmailChecked){
                setLoadingState("Sending email");
                setLoading(true);
                const payload = handleDonePayload(values);

                if( props.setShowShareStudyLinkModal != undefined){
                    props.setShowShareStudyLinkModal(false);
                }
                shareStudyByMail(payload);
                setLoading(false);
            }else{
                setShowShareStudyLinkModal(false);
                if( props.setShowShareStudyLinkModal != undefined){
                    props.setShowShareStudyLinkModal(false);
                }
            }
        }
      });

      let PrimaryButtonList = [
        {
            title:t("button.share"),
            onclick: handleSubmit,
            disabled: !isEmailChecked
        }
    ];
    let DefaultButtonList = [
        {
            title:t("button.close"),
            onclick: handleClose
        }
    ];
    const contentStyles =  {
        root:{
          backgroundColor: 'rgb(22, 21, 20, 0.7)'
       },
    };

    const Containerstyles=  {
        root:{
          backgroundColor: 'rgb(22, 21, 20, 0.7)'
       },
        main:{
          boxSizing: "border-box",
          borderRadius: "10px 10px 10px 10px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: "1px solid #4B4B4B",
          width : "500px",
        },
        // modalBody:{
        //   padding: "20px",
        //   backgroundColor: "#191919",
        //   border:"1px solid white",
        // }
      }

    const modalDetails = {
        header: <ModalHeader updatedModal = {true} showPatientDetails={false} heading={t("share-study.title")} handleCancel={handleClose}/>,
        footer : <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={(process.env.REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY == "true" || process.env.REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY == true) ? PrimaryButtonList : []}/>,
        body : <ShareStudyLinkBody handleEmailcheck={handleEmailcheck} setIsEmailChecked={setIsEmailChecked} isEmailChecked={isEmailChecked} values={values} handleChange={handleChange} studyId="71" errors={errors}/>,
        width : "500px",
        height: "360px"
      }

  return (
    <>
        <ModalMain showModal={true} modalDetails={modalDetails}/>
    </>
  )
}

export default ShareStudyLink